import { MissionsList } from "@/components/missions/MissionsList";

export const meta = () => [
  { title: "Missions | Ani Tech" },
  { name: "description", content: "Active client missions" },
];

export default function MissionsRoute() {
  return <MissionsList />;
}

type MissionsListRouteProps = {
  focusKey?: string | null;
};

/** Named export consumed by OS-mode window registry. */
export function MissionsListRoute({ focusKey = null }: MissionsListRouteProps = {}) {
  return <MissionsList focusKey={focusKey} />;
}
